import axios from 'axios';
import { BASE_URL } from './constants';

export const api = axios.create({
  baseURL: BASE_URL, /// your API url goes here
  responseType: 'json',
  timeout: 15000,
});
